import { render } from "./remark_group_new.vue?vue&type=template&id=657d570b"
import script from "./remark_group_new.vue?vue&type=script&lang=js"
export * from "./remark_group_new.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__